import angular from 'angular';

angular.module('AaApp.Opp').constant('smtpProviderTypes', {
    none: 0,
    autoAlert: 1,
    custom: 2
});
